var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-popup',{attrs:{"close-on-click-overlay":false},model:{value:(_vm.showState),callback:function ($$v) {_vm.showState=$$v},expression:"showState"}},[_c('img',{staticClass:"qrcode",attrs:{"src":"https://res.peki.vip/20220913/c006108f76ae47318a547338eaceaa27.jpeg"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }